import * as React from 'react'
import FormFields from '../../resources_records/FormFields'
import useResourcesRecordFormController, { ResourcesRecordFormController } from '../../../hooks/useResourcesRecordFormController'
import { useCreateResourcesRecordMutation } from '../../../hooks/queries/resources_records'
import { ResourcesRecordShape } from '../../../api/api_data_types'
import { resources_records_path } from '../../../routes'
import ErrorMessage from '../list_app/ErrorMessage'
import TemplateManager from '../../resources_records/TemplateManager'
import { useContext } from 'react'
import CommonContext from '../../CommonContext'

type TimeRegistrationFormProps = {
  record: ResourcesRecordShape
}

export default function TimeRegistrationForm(props: TimeRegistrationFormProps) {
  const { record } = props
  const dictionaries = useContext(CommonContext)
  const { currentUser, updateCurrentUser } = dictionaries
  const { formData, setFormData, transform, successfullyCreated, setSuccessfullyCreated } = useResourcesRecordFormController(record)
  const mutation = useCreateResourcesRecordMutation(() => setSuccessfullyCreated(true))
  const handleSubmit = e => {
    e.preventDefault()
    mutation.mutate({ resources_record: transform(formData) })
  }

  return (
    <form onSubmit={handleSubmit} action={resources_records_path({ format: 'json' })} method="POST">
      {successfullyCreated && <div className="alert alert-success"> Record successfully created! </div>}
      {!successfullyCreated && (
        <>
          <TemplateManager formData={formData} setFormData={setFormData} currentUser={currentUser} updateCurrentUser={updateCurrentUser} />
          <FormFields
            record={record}
            formData={formData}
            setFormData={setFormData}
            availableWorktypes={currentUser.available_worktypes}
            availableWorkcards={[]}
            availableWarehouses={currentUser.available_warehouses}
            availableMachines={currentUser.available_machines}
            availablePartners={[]}
            allPartners={[]}
            allowPartners={false}
            hideMachines={currentUser.hide_machines}
            hideItems={currentUser.hide_items}
            hidePackagings={currentUser.hide_packagings}
            hideShipments={currentUser.hide_shipments}
            hidePurchases={currentUser.hide_purchases}
          />
        </>
      )}
      {mutation.isError && (
        <div className="resources-record-modal-error">
          <ErrorMessage className="d-inline error-message" error={mutation.error} isError={mutation.isError} />
          <div>Make sure you have all fields properly filled and try again.</div>
        </div>
      )}
      <div className="resources-record-modal-actions popup-actions">
        {!successfullyCreated && (
          <button type="submit" className="btn btn-primary" disabled={mutation.isLoading}>
            {mutation.isLoading ? <i className="fa fa-spinner fa-spin" /> : 'Save'}
          </button>
        )}
      </div>
    </form>
  )
}
